import {
  WebsiteApprovalListSchema,
  WebsiteApprovalLogEntrySchema,
  WebsiteBulkDecisionResultSchema,
  type WebsiteApprovalEntityType,
  type WebsiteApprovalList,
  type WebsiteApprovalLogEntry,
  type WebsiteApprovalRef,
  type WebsiteApprovalsQuery,
  type WebsiteBulkDecisionResult,
} from '@utazzo/shared';
import { z } from 'zod';

import { apiClient } from '@/lib/api-client';

const BASE = '/admin/website-approvals';

export const listWebsiteApprovals = async (
  query: WebsiteApprovalsQuery,
): Promise<WebsiteApprovalList> => {
  const { data } = await apiClient.get<unknown>(BASE, { params: query });
  return WebsiteApprovalListSchema.parse(data);
};

export const getWebsiteApprovalHistory = async (
  type: WebsiteApprovalEntityType,
  id: string,
): Promise<WebsiteApprovalLogEntry[]> => {
  const { data } = await apiClient.get<unknown>(`${BASE}/${type}/${id}/history`);
  return z.array(WebsiteApprovalLogEntrySchema).parse(data);
};

export const approveWebsiteItem = async (
  type: WebsiteApprovalEntityType,
  id: string,
  note?: string,
): Promise<unknown> => {
  const { data } = await apiClient.post(`${BASE}/${type}/${id}/approve`, { note });
  return data;
};

export const rejectWebsiteItem = async (
  type: WebsiteApprovalEntityType,
  id: string,
  note?: string,
): Promise<unknown> => {
  const { data } = await apiClient.post(`${BASE}/${type}/${id}/reject`, { note });
  return data;
};

export const bulkApproveWebsiteItems = async (
  items: WebsiteApprovalRef[],
  note?: string,
): Promise<WebsiteBulkDecisionResult> => {
  const { data } = await apiClient.post<unknown>(`${BASE}/bulk-approve`, { items, note });
  return WebsiteBulkDecisionResultSchema.parse(data);
};

export const bulkRejectWebsiteItems = async (
  items: WebsiteApprovalRef[],
  note?: string,
): Promise<WebsiteBulkDecisionResult> => {
  const { data } = await apiClient.post<unknown>(`${BASE}/bulk-reject`, { items, note });
  return WebsiteBulkDecisionResultSchema.parse(data);
};

/** Sends one record to the website manager. Lives on the per-surface route. */
const SUBMIT_PATH: Record<WebsiteApprovalEntityType, string> = {
  BLOG: '/admin/website/blogs',
  DESTINATION_PAGE: '/admin/website/destination-pages',
  CATEGORY_PAGE: '/admin/website/category-pages',
};

export const submitForReview = async (
  type: WebsiteApprovalEntityType,
  id: string,
): Promise<unknown> => {
  const { data } = await apiClient.post(`${SUBMIT_PATH[type]}/${id}/submit-for-review`);
  return data;
};
